<template>
  <div v-if="(galas.length > 0 && galasWithEnabledNotifications !== null && !(galasStatus === 'Wyroznione' && window.size.mobile)) || dataLoading" class="pb-6 zt-h2-page">
    <div v-if="galasStatus !== 'Wyroznione'" class="w-full text-xl font-semibold flex flex-nowrap justify-between items-center pr-2.5 pl-2">
      <h2 v-if="galasStatus === 'Nadchodzace'" class="!mt-0 !mb-4">Nadchodzące {{window.size.desktop ? 'gale' : ''}}</h2>
      <h2 v-else-if="galasStatus === 'Przeszle'" class="!mt-0 !mb-4"> {{window.size.mobile ? 'Ostatnie wyniki' : 'Wyniki ostatnich gal'}}</h2>
      <button v-if="!isSearchingEnabled" :id="this.galasStatus + '-all-button'" class="py-1 zt-hover font-normal px-2 border-[1px] border-zt-light bg-zt-light/10 rounded-zt text-xs" @click="changeTab">Wszystkie</button>
      <div v-else class="relative inline-flex items-center justify-end"
           :class="{ 'z-backdrop': isRelationPlannedModalOpen }">
        <Transition name="fade">
          <SelectRelationPlannedModal
              v-if="isRelationPlannedModalOpen"
              :selectedOption="selectedOption"
              @close-modal="closeModal">
          </SelectRelationPlannedModal>
        </Transition>
        <button class="bg-transparent flex flex-nowrap items-center" @click.stop="openModal()"
                :class="{'opacity-50 pointer-events-none cursor-default': dataLoading}">
          <div class="flex flex-nowrap items-center gap-1.5 text-[#EEE] mb-4 text-sm font-light hover:opacity-80">
            <span v-if="selectedOption === 1">Wszystkie</span>
            <span v-else-if="selectedOption === 2">Z relacją</span>
            <span v-else-if="selectedOption === 3">Freak fight</span>
            <span v-else-if="selectedOption === 4">Na gołe pięści</span>
            <span v-else-if="selectedOption === 5">Piłkarskie</span>
            <svg :class="isRelationPlannedModalOpen ? 'rotate-180' : ''" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.24875 0.084583L4.5 3.32875L7.75125 0.0845832L8.75 1.08333L4.5 5.33333L0.25 1.08333L1.24875 0.084583Z" fill="white" />
            </svg>
          </div>
        </button>
      </div>
    </div>
    <div v-else-if="galasStatus === 'Wyroznione'" class="px-2 xl:pr-0">
      <h2 class="!mt-0 !mb-4 ml-2">Główne wydarzenia</h2>
    </div>
    <div class="space-y-3">
      <template v-if="isSearchingEnabled">
<!--        <div class="text-zt-more text-sm px-2 xl:px-0 xl:text-xl">{{galasStatus === 'Przeszle' ? 'OSTATNIE 7 DNI' : 'NAJBLIŻSZE 7 DNI'}}</div>-->
        <div v-if="false" v-click-outside="searchingClickOutside" class="flex items-center bg-[#263346] rounded-zt text-sm grow w-full xl:text-lg"
             :class="{ 'ring ring-zt-light': searchInputFocus }">
          <input class="pl-4 flex-1" type="search" placeholder="Wyszukaj..." v-model="searchInput"
                 @focus="searchInputFocus = true" @input="handleSearchInput" @keyup.enter="handleSearchEnter" @click="handleCount(6)"/>
          <div class="px-4 py-2 zt-hover cursor-pointer" @click="handleCount(6)">
            <svg v-if="window.size.desktop" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.69423 16.8817C12.9436 16.8817 16.3885 13.4384 16.3885 9.19086C16.3885 4.94331 12.9436 1.5 8.69423 1.5C4.44483 1.5 1 4.94331 1 9.19086C1 13.4384 4.44483 16.8817 8.69423 16.8817Z" stroke="white" stroke-width="1.66688" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14.8438 15.3477L20.9991 21.5003" stroke="white" stroke-width="1.66688" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg v-if="window.size.mobile" @click="handleSearchEnter" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.57832 12.4017C9.65914 12.4017 12.1566 9.90534 12.1566 6.82587C12.1566 3.7464 9.65914 1.25 6.57832 1.25C3.4975 1.25 1 3.7464 1 6.82587C1 9.90534 3.4975 12.4017 6.57832 12.4017Z" stroke="white" stroke-width="1.66688" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11.0391 11.2891L15.5017 15.7498" stroke="white" stroke-width="1.66688" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </template>
      <GalaItem v-for="gala in filteredGalasToShow" :key="gala.id"
                :data="gala"
                :gala-status="galasStatus"
                :is-in-sidebar="true"
                :isFeaturedGala="this.galasStatus === 'Wyroznione'"
                :galaHour="gala.hour">
      </GalaItem>
    </div>
    <button v-if="isSearchingEnabled && filteredGalasToShow.length > 0"
            class="block mx-auto" :class="{'mt-6' : filteredGalasToShow.length < filteredGalas.length}"
            @click="galasShowCount += 5; markGalasDivFilters(); expandAnalytic()"
            aria-label="Rozwiń">
      <span v-if="filteredGalasToShow.length < filteredGalas.length" class="underline pt-1 text-sm zt-hover uppercase text-zt-more text-[14px]">Rozwiń</span>
    </button>
    <div v-else-if="dataLoading"
         class="w-full h-full mt-2 flex flex-col justify-center items-center xl:!mt-10">
      <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
      </svg>
      <span class="mt-4 animate-bounce">Ładowanie gal</span>
    </div>
    <div v-else-if="isSearchingEnabled" class="w-full text-center opacity-75 mt-4">BRAK</div>
  </div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';
import SelectRelationPlannedModal from '../components/modals/SelectRelationPlannedModal.vue';
import GalaItem from '../components/GalaItem.vue';
import {weekDayToString} from "../../assets/js/utils";

export default {
  name: 'GalaSchedule',
  components: {
    SelectRelationPlannedModal,
    GalaItem,
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  data() {
    return {
      galas: [],
      otherGalas: [],
      galasShowAll: false,
      galasShowCount: 5,
      otherGalasShowCount: 5,
      searchPhrase: '',
      searchPhrase2: '',
      searchInput: '',
      searchInput2: '',
      searchInput2Focus: false,
      isRelationPlannedModalOpen: false,
      searchInputFocus: false,
      selectedOption: 1,
      isSearchingEnabled: true,
      galasStatus: this.$attrs.type ?? '',
      galasWithEnabledNotifications: [],
      searchingClickOutside: {
        handler: this.outsideClick,
        events: ['touchend', 'mouseup']
      },
      searching2ClickOutside: {
        handler: this.outsideClickInput2,
        events: ['touchend', 'mouseup']
      },
      dataLoading: true
    };
  },
  mounted() {
    this.loadEndedGalas();
    this.getSavedNotifications();
    if (this.galasStatus === 'Przeszle' && window.size.desktop) {
      this.galasShowCount = 10;
    }
    // setInterval(() => {
    //   let element = document.getElementsByClassName('nowe-gale-wyroznione');
    //   if (element.length > 0) {
    //     this.isSearchingEnabled = !element[0]?.classList.contains('zt-visible');
    //     if (this.galasShowCount <= 10 || !this.isSearchingEnabled) {
    //       this.galasShowCount = this.isSearchingEnabled ? 5 : 5;
    //     }
    //   } else {
    //    this.isSearchingEnabled = false;
    //   }
    // }, 100);
  },
  computed: {
    filteredGalas() {
      if (this.galasStatus === 'Wyroznione') {
        return this.galas.sort((a,b) => {
          if (a.status === 'IP' && b.status !== 'IP') {
            return -1;
          } else if (b.status === 'IP' && a.status !== 'IP') {
            return 1;
          } else {
            return 0;
          }
        });
      }
      if (this.galas.length > 0) {
        return this.galas.filter(gala => {
          // let param = (gala.is_relation_planned === '0' || (gala.is_relation_planned === '1' && ((gala.dateDiff.days > 6 && this.galasStatus === 'Nadchodzace') || (gala.dateDiff.days < -3 && this.galasStatus === 'Przeszle'))))
          // const nameMatch = gala.name.toLowerCase().includes(this.searchPhrase.toLowerCase());
          // const dateMatch = gala.formatedGalaDate.toLowerCase().includes(this.searchPhrase.toLowerCase());
          // const relationMatch = gala.relation.toLowerCase().includes(this.searchPhrase.toLowerCase());
          // const fightsMatch = gala.hasFights.toLowerCase().includes(this.searchPhrase.toLowerCase());
          // return (nameMatch || dateMatch || relationMatch || fightsMatch) && param;
          if (gala.dateDiff.days <= 4 && gala.dateDiff.days >= -2 && !this.isSearchingEnabled) {
            return false;
          }
          if (this.selectedOption === 1) { // wszystkie
            return gala.federation_name !== 'High League';
          } else if (this.selectedOption === 2) { // z planowaną relacją
            return gala.is_relation_planned === '1' && gala.federation_name !== 'High League';
          } else if (this.selectedOption === 3) { // freak fight
            return gala.federation_type === 'Freak fight' && gala.federation_name !== 'High League';
          } else if (this.selectedOption === 4) { // na gołe pięści
            return gala.federation_type === 'Na gole piesci' && gala.federation_name !== 'High League';
          } else if (this.selectedOption === 5) { // piłkarskie
            return gala.federation_type === 'Pilkarskie' && gala.federation_name !== 'High League';
          } else {
            return false;
          }
        });
      } else return [];
    },
    filteredGalasToShow() {
      if (this.galasStatus === 'Wyroznione') {
        return this.galas.sort((a,b) => {
          if (a.status === 'IP' && b.status !== 'IP') {
            return -1;
          } else if (b.status === 'IP' && a.status !== 'IP') {
            return 1;
          } else {
            return 0;
          }
        });
      }
      if (this.galas.length > 0) {
        return this.filteredGalas.slice(0, this.galasShowCount);
      } else return [];
    },
  },
  methods: {
    loadEndedGalas() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_galas_to_martial_sports_page',
        type: this.galasStatus
      }).then(response => {
        if (response.data.success) {
          this.galas = response.data.data;
          let counter = 1;
          this.galas.forEach(gala => {
            let dateParts = gala.month.split('-');
            let day, month, year;
            if (dateParts.length === 3) {
              [day, month, year] = dateParts;
            } else if (dateParts.length === 2) {
              [month, year] = dateParts;
              day = new Date(year, month, 0).getDate();
            }
            let dateObj = new Date(`${year}-${month}-${day}T00:00:00`);
            let timestamp = dateObj.getTime()/1000;
            gala.formatedGalaDate = this.formatGalaDate(timestamp, gala.hour, gala.month);
            gala.relation = gala.is_relation_planned === '1' ? 'Relacja' : '';
            gala.hasFights = gala.post_link?.length > 0 ? 'Wyniki' : '';
            let now = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            let galaDate = DateTime.fromSeconds(timestamp).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            gala.dateDiff = galaDate.diff(now, ['days', 'hours', 'minutes']);
            // gala.isDefaultUnfolded = (Number(gala.is_relation_planned) === 1 && counter <= this.galasShowCount);
            gala.isDefaultUnfolded = false;
            counter++;
            gala.userNotificationEnabled = this.galasWithEnabledNotifications?.some(g => {return Number(g.event_id) === Number(gala.id)});
          });
        }
        this.dataLoading = false;
      })
    },
    changeTab() {
      let sectionClass = 'nowe-gale-' + this.galasStatus.toLowerCase();
      const button = document.querySelector(`.swiper-wrapper div[data-section-class="${sectionClass}"]`);
      if (button) {
        button.click();
      }
    },
    formatGalaDate(timestamp, hour, month, upcoming = false) {
      let now = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      let galaDate = DateTime.fromSeconds(timestamp);
      if (month.length <= 7) {
        let splitedDate = month.split('-');
        return galaDate.toFormat('LLLL') + ' ' + splitedDate[1];
      }
      let diff = galaDate.diff(now, ['days', 'hours', 'minutes']);
      if (upcoming && diff.days < 0) {
        return 'Zakończono';
      } else if (diff.days === -1) {
        return 'Wczoraj' + (hour.length > 0 ? ' (' + hour + ')' : '');
      } else if (diff.days === 0) {
        return 'Dziś' + (hour.length > 0 ? ' (' + hour + ')' : '');
      } else if (diff.days === 1) {
        return 'Jutro' + (hour.length > 0 ? ' (' + hour + ')' : '');
      } else if (diff.days > 1 && diff.days < 7) {
        let stringDate = galaDate.toFormat('EEEE') + (hour.length > 0 ? ' (' + hour + ')' : '');
        return stringDate.charAt(0).toUpperCase() + stringDate.slice(1);
      } else if (diff.days < 0 && diff.days > -7) {
        return -diff.days + ' dni temu ';
      } else {
        if (now.year !== galaDate.year) {
          return galaDate.toFormat('d MMMM yyyy')
        }
        return galaDate.toFormat('d MMMM') + (diff.days > 0 ? (hour.length > 0 ? ' (' + weekDayToString(galaDate.weekday) + ', ' + hour + ')' : '') : '');
      }
    },
    handleSearchInput() {
      if (window.size.desktop) {
        this.searchPhrase = this.searchInput;
        setTimeout(() => {
          this.markGalasDivFilters();
        }, 0);
      }
      if (window.size.mobile && !this.searchInput) {
        this.searchPhrase = this.searchInput;
        setTimeout(() => {
          this.markGalasDivFilters();
        }, 0);
      }
    },
    handleSearchEnter() {
      if (window.size.mobile) {
        this.searchPhrase = this.searchInput2;
        this.searchInput2Focus = false;
        setTimeout(() => {
          this.markGalasDivFilters();
        }, 0);
      }
    },
    outsideClick() {
      this.searchInputFocus = false;
    },
    outsideClickInput2() {
      this.searchInput2Focus = false;
    },
    markGalasDivFilters() {
      setTimeout(() => {
        const fightersDiv = document.querySelectorAll('.single-gala');

        fightersDiv.forEach(node => {
          const fields = [
            {selector: '.gala-name', property: 'textContent'},
            {selector: '.gala-date', property: 'textContent'},
            {selector: '.gala-relation', property: 'textContent'},
            {selector: '.gala-results', property: 'textContent'},
            {selector: '.gala-fight-card', property: 'textContent'}
          ];

          fields.forEach(({selector, property}) => {
            const fieldNode = node.querySelector(selector);
            if (!fieldNode) return;

            const childNodes = [...fieldNode.childNodes];
            childNodes.forEach(child => {
              if (child.nodeType === Node.ELEMENT_NODE && child.tagName.toLowerCase() === 'svg') {
                return;
              }
              if (child.nodeType === Node.TEXT_NODE) {
                const fieldValue = child.textContent.toLowerCase();

                child.nodeValue = child.nodeValue.replace(/(<span class="bg-\[#6FAD6E99]">|<\/span>)/gi, '');

                if (fieldValue.includes(this.searchPhrase.toLowerCase())) {
                  const regex = new RegExp(this.searchPhrase, 'gi');
                  const highlightedText = child.nodeValue.replace(regex, match => `<span class="bg-[#6FAD6E99]">${match}</span>`);
                  const span = document.createElement('span');
                  span.innerHTML = highlightedText;
                  fieldNode.replaceChild(span, child);
                }
              }
            });
          });
        });
      }, 0);
    },
    openModal() {
      this.isRelationPlannedModalOpen = true;
      this.blockScrolling();
	    if (window.location.pathname !== '/sporty-walk/') {
		    return;
	    }
	    let name = '';
	    if (this.galasStatus === 'Nadchodzace') {
		    name = 'Filtrator w Nadchodzących';
	    }
	    if (this.galasStatus === 'Przeszle') {
		    name = 'Filtrator w Ostatnich wynikach';
	    }
	    if (name !== '') {
		    this.countClicks(name);
	    }
    },
	  expandAnalytic() {
		  if (window.location.pathname !== '/sporty-walk/') {
			  return;
		  }
		  let name = '';
		  if (this.galasStatus === 'Nadchodzace') {
			  name = 'Rozwiń w Nadchodzących';
		  }
		  if (this.galasStatus === 'Przeszle') {
			  name = 'Rozwiń w Ostatnich wynikach';
		  }
		  if (name !== '') {
			  this.countClicks(name);
		  }
	  },
    closeModal(option) {
      this.selectedOption = option;
      this.isRelationPlannedModalOpen = false;
      this.unblockScrolling();
    },
    handleCount(number) {
      if (window.size.mobile) {
        countClicks('Zakladka sporty walki ' + number);
      }
    },
    getSavedNotifications() {
      let browserToken = localStorage.getItem("ztBrowserToken");
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_user_notification_subscryptions_by_type',
          notification_type: 'gala',
          browser_token: browserToken
        })
        .then(response => {
          if (response.data.success) {
            this.galasWithEnabledNotifications = response.data.data;
          }
        });
    },
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  z-index: 10;
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  z-index: 10;
  opacity: 0;
}
</style>